// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__uoKb8","card":"Contact_card__-pj4h"};